const START_ICON_MINIMIZED_STORAGE_KEY = 'aiChatStartIconMinimized';

const getSessionStorage = (): Storage | null => {
    if (typeof window === 'undefined') {
        return null;
    }

    try {
        return window.sessionStorage;
    } catch (error) {
        console.warn('[chatStartIconSession] sessionStorageを利用できません', error);
        return null;
    }
};

/**
 * 起動アイコンが閲覧セッション内で最小化済みか判定
 */
export const isChatStartIconMinimized = (): boolean => {
    const storage = getSessionStorage();
    if (!storage) {
        return false;
    }

    try {
        return storage.getItem(START_ICON_MINIMIZED_STORAGE_KEY) === 'true';
    } catch (error) {
        console.warn('[chatStartIconSession] 起動アイコンの最小化状態を読み込めませんでした', error);
        return false;
    }
};

/**
 * 起動アイコンの最小化状態を閲覧セッション内に保存
 */
export const saveChatStartIconMinimized = (): void => {
    const storage = getSessionStorage();
    if (!storage) {
        return;
    }

    try {
        storage.setItem(START_ICON_MINIMIZED_STORAGE_KEY, 'true');
    } catch (error) {
        console.warn('[chatStartIconSession] 起動アイコンの最小化状態を保存できませんでした', error);
    }
};
